import { gql } from '@apollo/client';

export const INSERT_TIMETABLE_TIMESLOT_CONFIGURATION = gql`
  mutation insert_timetable_timeslot_configuration($objects: [timetable_timeslot_configuration_insert_input!]!) {
    insert_timetable_timeslot_configuration(objects: $objects) {
      affected_rows
    }
  }
`;

export const DELETE_TIMETABLE_TIMESLOT_CONFIGURATION = gql`
  mutation delete_timetable_timeslot_configuration($where: timetable_timeslot_configuration_bool_exp!) {
    delete_timetable_timeslot_configuration(where: $where) {
      affected_rows
    }
  }
`;

export const TIMETABLE_TIMESLOT_CONFIGURATION = gql`
  query timetable_timeslot_configuration($where: timetable_timeslot_configuration_bool_exp) {
    timetable_timeslot_configuration(where: $where) {
      id
      day
      startTime
      endTime
      interval
    }
  }
`;
